import { ROUTE_NAMES } from "@/constants/routeConstants";

export default {
  methods: {
    mxGetMeetingRoute(meetingId) {
      return {
        name: ROUTE_NAMES.meeting,
        params: { id: this.$route.params.id, meetingId: meetingId },
      };
    },
    mxGetVotingRoute(meetingId, group = "") {
      return {
        name: ROUTE_NAMES.voting,
        params: {
          id: this.$route.params.id,
          meetingId: meetingId,
          group: group,
        },
      };
    },
    mxGetForumPost(cooperativeId, forumPostId) {
      return {
        name: ROUTE_NAMES.forumPost,
        params: { id: cooperativeId, topicId: forumPostId },
      };
    },
    mxGetTaskDetailRoute(id) {
      const route = {
        name: ROUTE_NAMES.taskDetail,
        params: {
          id: this.$route.params.id,
          taskId: id,
        },
      };
      return route;
    },
    mxGetSingleNotificationView(id, cooperativeId, global) {
      this.$store.commit("system/setSavedQuery", this.$route.query);
      if (global) {
        return {
          name: ROUTE_NAMES.emailNotificationDetail,
          params: { id: id },
        };
      }
      return {
        name: ROUTE_NAMES.oneNotification,
        params: { id: cooperativeId, notificationId: id },
      };
    },
    mxGetMaintenanceTask(id) {
      const route = {
        name: ROUTE_NAMES.maintenanceTask,
        params: {
          id: this.$route.params.id,
          maintenanceId: id,
        },
      };
      return route;
    },
    cooperativeUserRoute(item) {
      const route = {};
      if (this.$route.meta.adminModule) {
        if (this.$route.name === ROUTE_NAMES.cooperativeDetail) {
          route.name = ROUTE_NAMES.cooperativeUserDetail;
          route.params = {
            id: item.cooperativeId,
            userId: item.user.id,
          };
        } else {
          route.name = ROUTE_NAMES.apartmentUserDetail;
          route.params = {
            id: item.cooperativeId,
            apartmentId: item.apartmentId,
            userId: item.user.id,
          };
        }
      } else {
        if (this.$route.name === ROUTE_NAMES.cooperative) {
          route.name = ROUTE_NAMES.cooperativeUser;
          route.params = {
            id: item.cooperativeId,
            userId: item.user.id,
          };
        } else {
          route.name = ROUTE_NAMES.apartmentUser;
          route.params = {
            id: item.cooperativeId,
            apartmentId: item.apartmentId,
            userId: item.user.id,
          };
        }
      }
      this.$router.push(route);
    },
    searchRoute(keyword) {
      if (!keyword) return;
      const route = {};
      route.name = ROUTE_NAMES.search;

      route.query = { keyword };
      this.$router.push(route);
    },
  },
};
